export default "__VITE_ASSET__Czk1Qx8Y__"